document.addEventListener('DOMContentLoaded', () => {
  const input = document.getElementById('cart-discount-code');
  const button = document.getElementById('cart-discount-apply');
  const error = document.getElementById('cart-discount-error');

  if (!input || !button) return;

  const showError = (message) => {
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
  };

  const clearError = () => {
    if (!error) return;
    error.textContent = '';
    error.hidden = true;
  };

  const applyDiscount = () => {
    const code = input.value.trim();

    clearError();

    if (!code) {
      showError('Please enter a discount code.');
      return;
    }

    button.disabled = true;

    const redirectPath = `${window.location.pathname}${window.location.search}`;
    const applyUrl = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirectPath)}`;

    window.location.href = applyUrl;
  };

  button.addEventListener('click', applyDiscount);

  input.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      applyDiscount();
    }
  });
});